<template>
  <unicom-linha class="arquivo-anexo" :espacamento="false">
    <unicom-coluna sm="auto" style="padding-right: 12px">
      <IconeNormal class="icone" />
    </unicom-coluna>
    <unicom-coluna
      sm="auto"
      alinhamento="center"
      style="width: calc(100% - 84px); height: 100%; padding-bottom: 2px"
    >
      <unicom-linha :espacamento="false" style="height: 100%">
        <unicom-coluna sm="12">
          <div>
            <span class="negrito" style="padding-right: 12px">
              {{ objetoArquivo.nomeArquivo }}
            </span>
            <span class="segunda-cor-fonte">
              {{ objetoArquivo.tamanhoArquivo }}
            </span>
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" alinhamento="end" style="padding-bottom: 2px">
          <unicom-barra-progresso
            :valorAtual="barraProgresso"
            corBarraFundo="#DEE2E6"
            :corBarra="barraProgresso === 100 ? '#00995D' : '#B1D34B'"
          />
        </unicom-coluna>
      </unicom-linha>
    </unicom-coluna>
    <unicom-coluna sm="auto" class="ml-auto" style="height: 45px">
      <unicom-icone
        @click.native="$emit('cancelar-arquivo')"
        class="icone-acao"
        nome="x-circle"
        :tamanho="20"
        tooltipNome="Cancelar"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import IconeNormal from "../Icones/IconeNormal";

export default {
  components: {
    IconeNormal
  },
  props: {
    objetoArquivo: {
      type: Object,
      default: () => {
        return {
          nomeArquivo: "",
          tamanhoArquivo: 0,
          dataEnvio: "",
          dataAlteracao: "",
          descricao: " "
        };
      }
    },
    barraProgresso: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./Arquivo.scss";
</style>
